// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"prescriptionFileModal_imageContainer__X6fda","margin":"prescriptionFileModal_margin__kNGsu"};